import React, { useState } from "react";
import classnames from "classnames";
import "./styles.less";

let CodeMirror = null;
if (typeof window !== "undefined" && typeof window.navigator !== "undefined") {
  const { Controlled } = require("react-codemirror2");
  CodeMirror = Controlled;
  require("codemirror/lib/codemirror.css");
  require("codemirror/theme/material.css");
  require("codemirror/mode/htmlembedded/htmlembedded");
}

const codes = [
  `
  <!DOCTYPE html>
  <html>
  
  <head>
    <title></title>
    <script src="https://cdn.jsdelivr.net/npm/@authing/native-js-ui-components"></script>
    <!-- CSS 文件 -->
    <link href="https://cdn.jsdelivr.net/npm/@authing/native-js-ui-components/lib/index.min.css" rel="stylesheet"/>
  </head>
  
  <body>
    <!-- JavaScript 代码 -->
    <script type="text/javascript">
      var guard = new AuthingNativeJsUIComponents.AuthingGuard('AUTHING_APP_ID')
  
      // 事件监听
      guard.on('load', (authClient) => console.log(authClient))
    </script>
  </body>
  
  </html>
    `,
  `css`,
  `js`,
];

export const CommonCode = () => {
  const [tab, setTab] = useState(1);
  //   const tabitems = ["HTML", "CSS", "JS"];
  const tabitems = ["HTML"];
  return (
    <div>
      <div className="image-warp">
        <div className="image">
          <img src="//files.authing.co/authing-website/block-code-demo.jpg" alt="authing code" />
        </div>
        <div className="image">
          <div className="tab-code">
            <div>
              {tabitems.map((item, index) => {
                const cls = classnames({
                  "tab-item": true,
                  selected: tab === index + 1,
                });
                return (
                  <span
                    className={cls}
                    onClick={() => {
                      setTab(index + 1);
                    }}
                  >
                    {item}
                  </span>
                );
              })}
            </div>
            <i className="icon authing-icon authing-Nodejs tab-icon"></i>
          </div>
          <div>
            {CodeMirror && (
              <CodeMirror
                value={codes[tab - 1]}
                autoScroll={false}
                className="react-codemirror2"
                options={{
                  mode: "htmlembedded",
                  // mode: { name: "HTML" },
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
